module.exports = __webpack_public_path__ + "img/cbg.77a6bd8b.png";